/** どの版が動いているか(画面下部・ログイン画面に出す)。例: build 2026-10-08 15:00 / 58464c0 */
export const BUILD_LABEL = `build ${__BUILD_ID__} / ${__BUILD_COMMIT__}`;
